import React, { useState, useEffect } from "react";
import "./Fees_From.css";
import cancel from "../../../assets/cancel.png";
import Loader from "../../Loader/Loader";
import { toast } from "react-hot-toast";
import api from "../../../utils/api";

const Fees_Form = (props) => {
  const [details, setDetails] = useState({
    Class: "",
    section: "pre-primary",
    total: 0,
    lateFeeDate: "",
    months: [],
    duration: "none",
  });

  // Dynamic fee heads state
  const [feeHeads, setFeeHeads] = useState([
    { id: 1, name: "Tuition Fee", amount: 0 },
    { id: 2, name: "Computer Fee", amount: 0 },
    { id: 3, name: "Miscellaneous Fee", amount: 0 },
    { id: 4, name: "Late Fee", amount: 0 },
  ]);

  const [loading, setLoading] = useState(0);
  const [lateDate, setLateDate] = "single";
  const [selectedYear, setSelectedYear] = useState("");
  const [academicYears, setAcademicYears] = useState([]);
  const [open, setOpen] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const data = props.data;

  const handleClick2 = () => {
    props.setDisp();
    props.setEdit();
  };

  const getAutoSelectedMonths = (startMonth, duration) => {
    const monthIndex = months.indexOf(startMonth);
    if (monthIndex === -1) return [startMonth];

    if (duration === "monthly") {
      // Only select the clicked month
      return [startMonth];
    } else if (duration === "quarterly") {
      // Select 3 consecutive months
      return months.slice(monthIndex, Math.min(monthIndex + 3, 12));
    } else if (duration === "half-yearly") {
      // Select 6 consecutive months
      return months.slice(monthIndex, Math.min(monthIndex + 6, 12));
    } else if (duration === "yearly") {
      // Select all 12 months
      return months;
    }
    return [startMonth];
  };

  const handleChange = (e) => {
    if (e.target.name === "lateFeeDate") {
      const date = new Date(e.target.value);
      const day = date.getDate();
      if (day < 1 || day > 25) {
        alert("Please select a date between 1 and 25.");
        return;
      }

      setDetails({
        ...details,
        [e.target.name]: e.target.value,
      });
    } else if (e.target.name === "duration") {
      let changedData = { ...details, duration: e.target.value };
      // Auto-select months based on duration if months are already selected
      if (e.target.value === "monthly" || e.target.value === "quarterly" || e.target.value === "half-yearly" || e.target.value === "yearly") {
        if (details.months.length === 1) {
          changedData.months = getAutoSelectedMonths(details.months[0], e.target.value);
        } else if (details.months.length > 1) {
          const sorted = [...details.months].sort((a, b) => months.indexOf(a) - months.indexOf(b));
          changedData.months = getAutoSelectedMonths(sorted[0], e.target.value);
        } else if (details.months.length === 0) {
          // Auto-select first month (June) when no months are selected
          changedData.months = getAutoSelectedMonths(months[0], e.target.value);
        }
      } else if (e.target.value === "") {
        // If "None" is selected, clear all months
        changedData.months = [];
      }
      setDetails(changedData);
    } else {
      var changedData = { ...details };
      if (e.target.name == "section") {
        if (e.target.value == "primary") {
          // setDetails({
          //   ...details,
          //   "Class": 'I',
          // });
          changedData["Class"] = "I";
          // alert('primary')
        } else if (e.target.value == "secondary") {
          // setDetails({
          //   ...details,
          //   "Class": 'V',
          // });
          //alert('secondary')
          changedData["Class"] = "V";
        } else {
          // setDetails({
          //   ...details,
          //   "Class": null,
          // });
          // alert('other')
          changedData["Class"] = null;
        }
      }

      changedData[e.target.name] = e.target.value;
      setDetails(changedData);
    }
  };

  // Add a new fee head
  const addFeeHead = () => {
    const newId = feeHeads.length > 0 ? Math.max(...feeHeads.map((f) => f.id)) + 1 : 1;
    setFeeHeads([...feeHeads, { id: newId, name: "", amount: 0 }]);
  };

  // Remove a fee head
  const removeFeeHead = (id) => {
    setFeeHeads(feeHeads.filter((fee) => fee.id !== id));
  };

  // Update fee head name or amount
  const updateFeeHead = (id, field, value) => {
    setFeeHeads(feeHeads.map((fee) => (fee.id === id ? { ...fee, [field]: field === "amount" ? parseFloat(value) || 0 : value } : fee)));
  };

  // Calculate total from all fee heads
  const calculateTotal = () => {
    return feeHeads.reduce((sum, fee) => sum + (parseFloat(fee.amount) || 0), 0);
  };

  useEffect(() => {
    setIsEdit(props.isEdit);
  }, []);
  useEffect(() => {
    if (isEdit) {
      setDetails({
        ...details,
        section: parseInt(data.section),
        tuition: parseInt(data.tution),
        computer: parseInt(data.computer),
        miscellaneous: parseInt(data.miscellaneous),
        late: parseInt(data.late),
        admission: parseInt(data.admission_fee),
        term: parseInt(data.term_fee),
        lateFeeDate: 20,
        months: data.months,
        total: 20000,
        duration: data.duration || "none",
      });

      // Set academic year if available
      if (data.academic_year_id) {
        const academicYear = academicYears.find((year) => year.id === data.academic_year_id);
        if (academicYear) {
          setSelectedYear(academicYear);
        }
      }
    }
  }, [isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // alert(details.Class)
    setLoading(1);
    // alert(details.Class)
    if (!isEdit) {
      // console.dir(details);

      if (details.months.length == 0) {
        toast.error("have to slect atlest one month for add fee setup");
        setLoading(0);
      } else if (!selectedYear?.id) {
        toast.error("Please select an academic year");
        setLoading(0);
      } else {
        try {
          // Prepare the payload
          const payload = {
            section: details.section,
            cls: details.Class,
            total: details.total,
            late_date: details.lateFeeDate,
            months: details.months,
            duration: details.duration,
            academic_year_id: selectedYear.id,
            feeHeads: feeHeads, // Send dynamic fee heads
          };

          // Make the API call
          const response = await api.post("/feessetup", payload);

          // Check the status and handle the response
          if (response.status === 200) {
            console.log("Fee setup response:", response.data);
            setLoading(0); // Update loading state
            props.setDisp();
            props.onSuccess();
            toast.success("Fees setup added successfully");
          } else {
            toast.error(`Error: ${response.status} - ${response.statusText}`);
          }
        } catch (error) {
          // Handle API errors
          console.error("Error while setting up fees:", error);

          if (error.response) {
            // Errors with a response from the server
            toast.error(`Server Error: ${error.response.status} - ${error.response.data.message}`);
          } else if (error.request) {
            // Errors with no response (network issue)
            toast.error("Network Error: Please check your connection and try again.");
          } else {
            // Other errors
            toast.error("An error occurred. Please try again.");
          }
          setLoading(0); // Ensure loading state is reset
        }
      }
    } else {
      if (details.months.length == 0) {
        toast.error("have to slect atlest one month for add fee setup");
        setLoading(0);
      } else if (!details.duration) {
        toast.error("Please select a duration");
        setLoading(0);
      } else if (!selectedYear?.id) {
        toast.error("Please select an academic year");
        setLoading(0);
      } else {
        const response = await api.put(`/feesetup/${data.id}`, {
          section: details.section,
          total: details.total,
          late_date: details.lateFeeDate,
          months: details.months,
          duration: details.duration,
          academic_year_id: selectedYear.id,
          feeHeads: feeHeads, // Send dynamic fee heads
        });

        if (response.status === 200) {
          setLoading(0);
          props.setDisp();
          props.onSuccess();
          toast.success("Fees setup updated successfully");
        }
      }
    }
  };

  const months = ["june", "july", "august", "september", "october", "november", "december", "january", "february", "march", "april", "may"];

  // Helper function to check if a month should be disabled
  const isMonthDisabled = (month) => {
    if (!details.duration || details.duration === "none" || details.duration === "") {
      return false; // No restrictions when no duration is selected
    }

    // If no months are selected yet, all months are enabled
    if (details.months.length === 0) {
      return false;
    }

    // If the month is already selected, it should not be disabled
    if (details.months.includes(month)) {
      return false;
    }

    // For all other cases, disable months that are not in the selected range
    return true;
  };

  const handleMonth = (data) => {
    let newList = [];
    if (details.months.includes(data)) {
      // Uncheck the month
      newList = details.months.filter((month) => month !== data);
    } else {
      if (details.duration === "monthly") {
        newList = [data];
      } else if (details.duration === "quarterly") {
        newList = getAutoSelectedMonths(data, details.duration);
      } else if (details.duration === "half-yearly") {
        newList = getAutoSelectedMonths(data, details.duration);
      } else if (details.duration === "yearly") {
        newList = months;
      } else {
        newList = [...details.months, data];
      }
    }
    setDetails({
      ...details,
      months: newList,
    });
  };

  const fetchData = async () => {
    await api
      .get("/academic")
      .then((response) => response.data)
      .then((data) => {
        const activeYear = data?.find((item) => item?.is_active);
        const formattedActiveYear = {
          label: new Date(activeYear?.start_date).getFullYear() + "-" + new Date(activeYear?.end_date).getFullYear(),
          from: activeYear?.start_date,
          to: activeYear?.end_date,
          id: activeYear?.id,
        };
        setSelectedYear(formattedActiveYear);
        setAcademicYears(
          data
            ?.filter((item) => !item?.is_active)
            .map((item) => ({
              label: new Date(item?.start_date).getFullYear() + "-" + new Date(item?.end_date).getFullYear(),
              from: item?.start_date,
              to: item?.end_date,
              id: item?.id,
            })),
        );
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const total = calculateTotal();
    setDetails((prev) => ({ ...prev, total }));
  }, [feeHeads]);

  const handleYearChange = (e) => {
    const year = academicYears.find((y) => y.label === e.target.value);
    setOpen(true);
    setSelectedYear(year);
  };

  const getMinDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`;
  };

  const getMaxDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-25`;
  };

  // Helper function to check if a quick select button should be disabled
  const isQuickSelectDisabled = (range) => {
    if (!details.duration || details.duration === "none" || details.duration === "") {
      return false; // No restrictions when no duration is selected
    }

    const rangeMonthCounts = {
      "abect-all": 0,
      "june-may": 12,
      "june-aug": 3,
      "apr-jun": 3,
      "june-dec": 7,
      "oct-dec": 3,
      "dec-june": 7,
    };

    const durationMonthCounts = {
      monthly: 1,
      quarterly: 3,
      "half-yearly": 6,
      yearly: 12,
    };

    const expectedCount = durationMonthCounts[details.duration];
    const rangeCount = rangeMonthCounts[range];

    // Disable if the range doesn't match the expected count
    // Exception: "abect-all" is always enabled
    if (range === "abect-all") {
      return false;
    }

    return rangeCount !== expectedCount;
  };

  const handleQuickSelect = (range) => {
    let selectedMonths = [];
    let updatedDetails = { ...details };

    switch (range) {
      case "abect-all":
        selectedMonths = [];
        // Reset duration when clearing all months
        updatedDetails.duration = "";
        break;
      case "june-may":
        // Full academic year: April to March
        selectedMonths = ["june", "july", "august", "september", "october", "november", "december", "january", "february", "march", "april", "may"];
        break;
      case "june-aug":
        // January to March
        selectedMonths = ["june", "july", "august"];
        break;
      case "apr-jun":
        // April to June
        selectedMonths = ["april", "may", "june"];
        break;
      case "june-dec":
        // January to June
        selectedMonths = ["june", "july", "august", "september", "october", "november", "december"];
        break;
      case "dec-june":
        // December to June
        selectedMonths = ["december", "january", "february", "march", "april", "may", "june"];
        break;
      case "oct-dec":
        // October to December
        selectedMonths = ["october", "november", "december"];
        break;
      default:
        selectedMonths = details.months;
    }

    updatedDetails.months = selectedMonths;
    setDetails(updatedDetails);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="setup__form_div_open">
        <div className="setup__form">
          <div className="setup__form_header" style={{ width: "100%", padding: "0" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
              <h1 style={{ padding: "0", margin: "0", fontSize: "24px" }}>Add New Fees Setup</h1>
              <div className="setup__form_img" onClick={handleClick2}>
                <img src={cancel} alt="cancel" />
              </div>
            </div>
          </div>

          {/* Quick Selection Buttons */}
          <div className="setup__form_input">
            <h5 style={{ textAlign: "center", marginBottom: "15px" }}>Quick Select</h5>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                justifyContent: "center",
                marginBottom: "20px",
              }}
            >
              <button
                type="button"
                onClick={() => handleQuickSelect("abect-all")}
                disabled={isQuickSelectDisabled("abect-all")}
                style={{
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: details.months.length === 0 ? "2px solid #007bff" : "1px solid #ddd",
                  backgroundColor: details.months.length === 0 ? "#e3f2fd" : "#fff",
                  cursor: isQuickSelectDisabled("abect-all") ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontWeight: details.months.length === 0 ? "600" : "normal",
                  transition: "all 0.2s",
                  opacity: isQuickSelectDisabled("abect-all") ? 0.5 : 1,
                }}
              >
                Abect All
              </button>

              <button
                type="button"
                onClick={() => handleQuickSelect("june-may")}
                disabled={isQuickSelectDisabled("june-may")}
                style={{
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: "1px solid #ddd",
                  backgroundColor: details.months.length === 12 ? "#ff9800" : "#fff",
                  color: details.months.length === 12 ? "#fff" : "#333",
                  cursor: isQuickSelectDisabled("june-may") ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontWeight: details.months.length === 12 ? "600" : "normal",
                  transition: "all 0.2s",
                  opacity: isQuickSelectDisabled("june-may") ? 0.5 : 1,
                }}
              >
                June-May
              </button>

              <button
                type="button"
                onClick={() => handleQuickSelect("june-aug")}
                disabled={isQuickSelectDisabled("june-aug")}
                style={{
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: "1px solid #ddd",
                  backgroundColor: JSON.stringify(details.months.sort()) === JSON.stringify(["june", "july", "august"].sort()) ? "#ff9800" : "#fff",
                  color: JSON.stringify(details.months.sort()) === JSON.stringify(["june", "july", "august"].sort()) ? "#fff" : "#333",
                  cursor: isQuickSelectDisabled("june-aug") ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontWeight: JSON.stringify(details.months.sort()) === JSON.stringify(["june", "july", "august"].sort()) ? "600" : "normal",
                  transition: "all 0.2s",
                  opacity: isQuickSelectDisabled("june-aug") ? 0.5 : 1,
                }}
              >
                June-Aug
              </button>

              <button
                type="button"
                onClick={() => handleQuickSelect("june-dec")}
                disabled={isQuickSelectDisabled("june-dec")}
                style={{
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: "1px solid #ddd",
                  backgroundColor: JSON.stringify(details.months.sort()) === JSON.stringify(["june", "july", "august", "september", "october", "november", "december"].sort()) ? "#ff9800" : "#fff",
                  color: JSON.stringify(details.months.sort()) === JSON.stringify(["june", "july", "august", "september", "october", "november", "december"].sort()) ? "#fff" : "#333",
                  cursor: isQuickSelectDisabled("june-dec") ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontWeight: JSON.stringify(details.months.sort()) === JSON.stringify(["june", "july", "august", "september", "october", "november", "december"].sort()) ? "600" : "normal",
                  transition: "all 0.2s",
                  opacity: isQuickSelectDisabled("june-dec") ? 0.5 : 1,
                }}
              >
                June-Dec
              </button>

              <button
                type="button"
                onClick={() => handleQuickSelect("oct-dec")}
                disabled={isQuickSelectDisabled("oct-dec")}
                style={{
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: "1px solid #ddd",
                  backgroundColor: JSON.stringify(details.months.sort()) === JSON.stringify(["october", "november", "december"].sort()) ? "#ff9800" : "#fff",
                  color: JSON.stringify(details.months.sort()) === JSON.stringify(["october", "november", "december"].sort()) ? "#fff" : "#333",
                  cursor: isQuickSelectDisabled("oct-dec") ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontWeight: JSON.stringify(details.months.sort()) === JSON.stringify(["october", "november", "december"].sort()) ? "600" : "normal",
                  transition: "all 0.2s",
                  opacity: isQuickSelectDisabled("oct-dec") ? 0.5 : 1,
                }}
              >
                Oct-Dec
              </button>

              <button
                type="button"
                onClick={() => handleQuickSelect("dec-june")}
                disabled={isQuickSelectDisabled("dec-june")}
                style={{
                  padding: "8px 16px",
                  borderRadius: "20px",
                  border: "1px solid #ddd",
                  backgroundColor: JSON.stringify(details.months.sort()) === JSON.stringify(["december", "january", "february", "march", "april", "may", "june"].sort()) ? "#ff9800" : "#fff",
                  color: JSON.stringify(details.months.sort()) === JSON.stringify(["december", "january", "february", "march", "april", "may", "june"].sort()) ? "#fff" : "#333",
                  cursor: isQuickSelectDisabled("dec-june") ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontWeight: JSON.stringify(details.months.sort()) === JSON.stringify(["december", "january", "february", "march", "april", "may", "june"].sort()) ? "600" : "normal",
                  transition: "all 0.2s",
                  opacity: isQuickSelectDisabled("dec-june") ? 0.5 : 1,
                }}
              >
                Dec-Jun
              </button>
            </div>
          </div>

          <div className="setup__form_input">
            <h5 style={{ textAlign: "center" }}>Months</h5>
            <div className="checkbox-grid">
              {months.map((month, index) => (
                <div className="form-group" key={index + "00"}>
                  <input
                    type="checkbox"
                    name={month}
                    value={month}
                    onChange={() => handleMonth(month)}
                    checked={details.months.includes(month)}
                    disabled={isMonthDisabled(month)}
                    style={{
                      cursor: isMonthDisabled(month) ? "not-allowed" : "pointer",
                    }}
                  />
                  <label
                    htmlFor={month}
                    style={{
                      opacity: isMonthDisabled(month) ? 0.5 : 1,
                      cursor: isMonthDisabled(month) ? "not-allowed" : "pointer",
                    }}
                  >
                    {month.substring(0, 1).toUpperCase() + month.substring(1)}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="setup__form_input input-row">
            <div className="input-group">
              <h5>Fee Frequency</h5>
              <select name="duration" id="duration" onChange={handleChange} value={details.duration} className="setup__form_input_small">
                <option value="">None</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="half-yearly">Half-Yearly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>
          </div>
          <div className="setup__form_input input-row">
            <div className="input-group">
              <h5>Section</h5>
              <select name="section" id="grades" onChange={handleChange} value={details.section}>
                <option value="pre-primary">Pre-Primary</option>
                <option value="pre-nursery">Pre-Nursery</option>
                <option value="nursery">Nursery</option>
                <option value="primary">Primary</option>
                <option value="secondary">Secondary</option>
              </select>
            </div>
            <div className="input-group">
              <h5 htmlFor="academicYear">Academic Year</h5>
              <select id="academicYear" value={selectedYear?.label} onChange={handleYearChange} style={{ padding: "8px", borderRadius: "8px", backgroundColor: "#fff" }} className="custom-select">
                {!selectedYear && (
                  <option value={""} style={{ pointerEvents: "none" }} disabled>
                    {"Select Academic Year"}
                  </option>
                )}
                {academicYears?.map((year) => (
                  <option key={year?.label} value={year?.label}>
                    {year?.label}
                  </option>
                ))}
              </select>
            </div>
            {(details.section === "primary" || details.section === "secondary") && (
              <div className="input-group">
                <h5>Class</h5>
                <select name="Class" id="class" onChange={handleChange} value={details.Class}>
                  {details.section === "primary" ? (
                    <>
                      <option value="I">I</option>
                      <option value="II">II</option>
                      <option value="III">III</option>
                      <option value="IV">IV</option>
                    </>
                  ) : (
                    <>
                      <option value="V">V</option>
                      <option value="VI">VI</option>
                      <option value="VII">VII</option>
                      <option value="VIII">VIII</option>
                      <option value="IX">IX</option>
                      <option value="X">X</option>
                    </>
                  )}
                </select>
              </div>
            )}
          </div>

          {/* Dynamic Fee Heads Section */}
          <div className="setup__form_input">
            <h5 style={{ textAlign: "center", marginBottom: "20px", fontSize: "18px", fontWeight: "600" }}>Dynamic Fee Heads</h5>

            <div className="fee-heads-container">
              <div className="fee-heads-header">
                <div>Dynamic Fee Head</div>
                <div>Amount</div>
                <div style={{ width: "40px" }}></div>
              </div>

              {feeHeads.map((fee) => (
                <div key={fee.id} className="fee-head-row">
                  <input type="text" value={fee.name} onChange={(e) => updateFeeHead(fee.id, "name", e.target.value)} placeholder="Enter fee name" className="fee-head-input" />
                  <div className="fee-amount-wrapper">
                    <span className="fee-currency-symbol">₹</span>
                    <input
                      type="number"
                      value={fee.amount}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        // If current value is 0 and user is typing, replace instead of append
                        if (fee.amount === 0 && newValue !== "" && newValue !== "0") {
                          updateFeeHead(fee.id, "amount", newValue);
                        } else {
                          updateFeeHead(fee.id, "amount", newValue);
                        }
                      }}
                      onFocus={(e) => {
                        // Select all text when focused so typing replaces the value
                        e.target.select();
                      }}
                      onBlur={(e) => {
                        // Set to 0 if empty
                        if (e.target.value === "" || e.target.value === null) {
                          updateFeeHead(fee.id, "amount", "0");
                        }
                      }}
                      placeholder="0"
                      className="fee-amount-input"
                    />
                  </div>
                  <button type="button" onClick={() => removeFeeHead(fee.id)} className="fee-delete-btn" title="Remove fee head">
                    🗑️
                  </button>
                </div>
              ))}

              <button type="button" onClick={addFeeHead} className="fee-add-btn">
                + Add Row
              </button>
            </div>
          </div>

          <div className="setup__form_input input-row">
            <div className="input-group">
              <h5>Late Fee Date</h5>
              <input required min={getMinDate()} type="date" name="lateFeeDate" value={details.lateFeeDate} onChange={handleChange} className="setup__form_input_small" />
            </div>
            <div className="input-group">
              <h5>Total Fee</h5>
              <input required type="number" name="total" disabled value={details.total} className="setup__form_input_small" placeholder="Total Fee" />
            </div>
          </div>
          <div>
            {loading ? (
              <Loader small={true} />
            ) : (
              <button className="setup__form_button" type="submit">
                <span style={{ color: "#fff" }}>Add Fees Setup</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default Fees_Form;
